import ChModel from './Ch';
import { TuneRequest, TuneSubscribeOption, resolveTuneRequest, tuneRequestInit, tuneSubscribeOptionInit } from '../talkn-config';

export type BootOption = {
  hasSlash: boolean;
  protocol: string;
  host: string;
  connection: string;
  tuneOption: TuneSubscribeOption;
  rankScope?: string;
  tuneRequest?: Partial<TuneRequest>;
  apiKey?: string;
  isObserver?: boolean;
};

export default class BootOptionModel {
  hasSlash = false
  protocol = ''
  host = ''
  connection = ChModel.rootConnection
  tuneOption = tuneSubscribeOptionInit
  static getConnection(connection: string) {
    if (connection === '') return ChModel.rootConnection;
    connection = connection.endsWith(ChModel.rootConnection) ? connection : `${connection}${ChModel.rootConnection}`;
    return connection.startsWith(ChModel.rootConnection) ? connection : `${ChModel.rootConnection}${connection}`;
  }
  static getTuneOptionString(tuneOption: TuneSubscribeOption): string {
    const entries: [string, string][] = [];
    Object.keys(tuneOption).forEach((key) => {
      const tuneOptionKey = key as keyof TuneSubscribeOption;
      entries.push([key, tuneOption[tuneOptionKey] ? '1' : '0']);
    });
    return new URLSearchParams(entries).toString();
  }
  static getTuneRequest(bootOption: Partial<BootOption> = {}): TuneRequest {
    return resolveTuneRequest({
      tuneOption: bootOption.tuneRequest?.tuneOption ?? bootOption.tuneOption ?? tuneRequestInit.tuneOption,
      rankScope: bootOption.tuneRequest?.rankScope ?? bootOption.rankScope,
    });
  }
  constructor(params: Partial<BootOption> = init) {
    return Object.assign(this, params);
  }
}

export const init: BootOption = {
  hasSlash: false,
  protocol: '',
  host: '',
  connection: '',
  tuneOption: {},
};
